import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Button, CircularProgress, Container, Typography } from '@mui/material';
import InformePartidoPageModern from './InformePartidoPageModern';
import { getReportExample } from '../services/reportExamplesService';

export default function ReportExamplePage() {
  const { slug } = useParams();
  const { t } = useTranslation('landing', { keyPrefix: 'commercial.samples' });
  const [example, setExample] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setExample(null);
    setError(false);
    getReportExample(slug, controller.signal)
      .then(data => { if (!controller.signal.aborted) setExample(data); })
      .catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [slug, attempt]);

  return (
    <>
      <Container sx={{ py: 2 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
          <Button component={Link} to="/#ejemplo" sx={{ minHeight: 44 }}>{t('backToExamples')}</Button>
          <Button onClick={() => setAttempt(value => value + 1)} disabled={!example && !error} sx={{ minHeight: 44 }}>{t('refresh')}</Button>
        </Box>
        <Alert severity="info">{t('liveNotice')}</Alert>
        {example && <Typography variant="body2" sx={{ mt: 1 }}>{t('scope', { season: example.season })}</Typography>}
        {error && <Alert severity="error" sx={{ mt: 2 }}>{t('loadError')}</Alert>}
        {!example && !error && <Box role="status" sx={{ p: 4, display: 'flex', gap: 2 }}><CircularProgress size={24} />{t('loading')}</Box>}
      </Container>
      {example && <InformePartidoPageModern key={`${slug}:${attempt}`} example={example} />}
    </>
  );
}
